import EmblaCarousel from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
import type { EmblaOptionsType } from 'embla-carousel';

export class ContentImageSlider {
    emblaOptions: EmblaOptionsType = { loop: true, align: 'start' };

    constructor() {
        const sliders = document.querySelectorAll<HTMLElement>('.content-images');

        sliders.forEach((slider) => {
            this.initSlider(slider);
        });
    }

    initSlider = (slider: HTMLElement): void => {
        const emblaViewportNode = slider.querySelector<HTMLElement>('.embla__viewport');
        const emblaPrevButtonNode = slider.querySelector<HTMLElement>('.embla__prev');
        const emblaNextButtonNode = slider.querySelector<HTMLElement>('.embla__next');

        if (!emblaViewportNode || !emblaPrevButtonNode || !emblaNextButtonNode) {
            return;
        }

        const emblaApi = EmblaCarousel(emblaViewportNode, this.emblaOptions, [ClassNames()]);

        emblaPrevButtonNode.addEventListener('click', () => emblaApi.scrollPrev(), false);
        emblaNextButtonNode.addEventListener('click', () => emblaApi.scrollNext(), false);
    };
}
